
import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton: React.FC = () => {
  const phoneNumber = "34652312433"; 
  const message = "Hola Juanma, he visto tu portfolio y me gustaría contactar contigo.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5, x: 50 }}
      animate={{ opacity: 1, scale: 1, x: 0 }}
      transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
      className="fixed bottom-8 right-8 z-[100]"
    >
      <div className="relative group">
        {/* Tooltip */}
        <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden sm:block">
          <div className="glass-panel px-4 py-2 rounded-lg border border-[#39FF14]/30 whitespace-nowrap">
            <span className="text-[10px] font-bold text-[#39FF14] uppercase tracking-widest">
              ¿Hablamos por WhatsApp?
            </span>
          </div>
        </div>

        {/* Button */}
        <motion.a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.1, rotate: 5 }}
          whileTap={{ scale: 0.9 }}
          className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#121212] border border-[#39FF14]/50 rounded-full shadow-[0_0_20px_rgba(57,255,20,0.3)] group-hover:shadow-[0_0_35px_rgba(57,255,20,0.6)] group-hover:border-[#39FF14] transition-all duration-300 relative overflow-hidden"
        >
          {/* Pulsing Aura */}
          <div className="absolute inset-0 bg-[#39FF14]/5 animate-pulse" />
          
          <MessageCircle className="text-[#39FF14] relative z-10 w-6 h-6 md:w-8 md:h-8" />
          
          {/* Glass Overlay for depth */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none" />
        </motion.a>

        {/* External Indicator Dot */}
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#39FF14] rounded-full border-2 border-[#121212] shadow-[0_0_10px_#39FF14] animate-bounce" />
      </div>
    </motion.div>
  );
};

export default WhatsAppButton;
